module.exports = __webpack_public_path__ + "img/clue07.42993739.png";